<template>
  <div>
    <van-popup v-model="show" round :style="{ minWidth: '80%' }" :close-on-click-overlay="false">
      <div class="topSty">
        <div class="title"> 存在未支付订单</div>
        <div class="movieImage"> <img class="img" :src="getPic()"> </div>
        <div class="movieName"> {{ getMovieName() }}</div>
        <div class="orderNo"> 订单编号:{{ movieDate?.orderNo }}</div>

        <div class="bottomBox">
          <div class="conte" @click="goBuy">继续支付</div>
        </div>
      </div>
      <div class="conteItem" @click="cancleOrder">
        <div style="font-size: 1rem;border-radius: 2rem;">取消订单</div>
      </div>
    </van-popup>

  </div>
</template>
<script>
export default {
  name: "",
  props: {
    movieDate: null
  },
  data() {
    return {
      show: true,
    };
  },
  components: {},
  methods: {
    getPic() {
      let pic = this.movieDate ? JSON.parse(this.movieDate?.orderDetail).moviePicUrl : ''
      return pic
    },
    getMovieName() {
      let movieName = this.movieDate ? JSON.parse(this.movieDate?.orderDetail).movieName : ''
      return movieName
    },
    goBuy() {
      // 统一跳转到统一支付页面，只需传订单号
      // 电影订单使用 orderNo
      this.$router.push({
        path: "/UnifiedCashier",
        query: {
          orderNo: this.movieDate?.orderNo,
        },
      });
    },
    cancleOrder() {
      this.$api
        .cancelPayment(this.movieDate.tripartiteOrderNo)
        .then((res) => {
          this.$Toast(res.msg);
          if (res.code == 0) {
            this.closed()
          }
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    closed() {
      this.$emit("closed");
    },
    change(value) {
      this.check = value
    },

  },
  mounted() {
    // console.log(this.good);
    // 进入页面显示在顶部
    window.scroll(0, 0);
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.bottomBox {
  margin-top: 1rem;
  margin-bottom: 0.7rem;

  width: 100%;
}

.topSty {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
  color: #666;
  background-color: white;
  border-radius: 1rem;
}

.van-popup {
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  background-color: #00000000;
  -webkit-transition: -webkit-transform .3s;
  transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  -webkit-overflow-scrolling: touch;
}

.overstyle {
  border-radius: 0.5rem;

}

.title {
  font-size: 1.1rem;
  width: 100%;
  padding: 1rem 0;
  border-bottom: 1px solid #DDD;
  text-align: center;

}

.img {
  width: 6.85rem;
  height: 9.14rem;
  min-width: 6.85rem;
  min-height: 9.14rem;
  border-radius: 0.5rem;
}


.orderNo {

  width: 100%;
  padding: 0.5rem 0;
  text-align: center;

}

.movieName {

  width: 100%;
  padding: 0.5rem 0;
  text-align: center;
  font-size: 1rem;
}

.movieImage {
  width: 100%;
  text-align: center;
  margin-top: 1rem;
}

.conteItem {
  margin: 0 auto;
  color: #ddd;
  padding: 0.5rem;
  text-align: center;
  border-radius: 1rem;
}

.conte {
  border-radius: 2rem;
  width: 95%;
  // width: 100%;
  text-align: center;
  height: 2.5rem;
  line-height: 2.5rem;
  margin-top: 0.5rem;
  background-image: linear-gradient(left, #ffc585 0%, #d59a54 100%);
  font-weight: 600;
  color: white;
  font-size: 1rem;
  margin: 0 auto;
}

.btn {
  height: 2.5rem;
  margin-top: 0.5rem;
}
</style>